var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ml-3 py-1 px-2 timebox shadow half-radius",class:{ blinking: _vm.recording }},[_vm._t("default",[_vm._v(_vm._s(_vm.time))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }